module.exports = __webpack_public_path__ + "static/partner_bg2-d8598f02aa1539d2b67b1179e4f623f1.png";